/**
 * FullPageLoader
 *
 * App-wide blocking loader used by the SCI global spinner. Renders a dimmed
 * backdrop over the whole viewport with a centered card containing a spinner
 * and an optional, dynamic loading message.
 */

import { Spinner } from '@makemydeal/ui-bricks/dist/cox';
import { LoaderBackdrop, LoaderCard, LoaderMessage } from './FullPageLoader.style';

export interface FullPageLoaderProps {
    /** Optional message rendered beneath the spinner. */
    message?: string;
}

const FullPageLoader = ({ message }: FullPageLoaderProps) => {
    return (
        <LoaderBackdrop data-testid="sci-full-page-loader" role="alertdialog" aria-busy="true" aria-live="assertive">
            <LoaderCard>
                <Spinner />
                {message && <LoaderMessage data-testid="sci-full-page-loader-message">{message}</LoaderMessage>}
            </LoaderCard>
        </LoaderBackdrop>
    );
};

export default FullPageLoader;
